import React from 'react';

import configs from 'configs';

const MemberItem = ({ member, onOpenModal, onToggleMember }) => (
  <div
    className={`profile-tile${member.parent_id > 0 ? ' is-child' : ''}`}
    style={{marginLeft: member.role > 2 ?`${(member.role)}rem` : null}}
  >
    <a className="profile-tile-box" aria-label={member.code ? 'Modifica agente' : 'Aggiungi agente'} onClick={onOpenModal}>
      <div className="pt-avatar-w">
        <img alt={member.name || ''}
          src={member.logo || `${configs.cdnHost}/assets/team-member-image-placeholder.jpg`}
        />
        <i className={`os-icon icon-edit ${member.code ? 'os-icon-edit' : 'os-icon-plus'}`} />
      </div>
      <div className="pt-user-name">
        {member.hasOwnProperty('name') ? member.name : 'Aggiungi'}
      </div>
      <div className={`status-pill ${member.status === 'ACTIVATED' ? 'green' : member.status === 'SUSPENDED' ? 'yellow' : ''}`}></div>
    </a>
    <div className="profile-tile-meta">
      <ul>
        <li>
          {member.business_name || ''}
        </li>
        <li>
          <small>
            {member.roleName && <span className="agent-role-name">{member.roleName}</span>}
            <a href={`mailto:${member.email}`} aria-label={`Invia Email a ${member.email}`}>{member.email}</a>
          </small>
        </li>
        <li>
          {member.status &&
            <small>
              status: {{
                'ACTIVATED': <div className="badge badge-success-inverted">attivato</div>,
                'SUSPENDED': <div className="badge badge-warning-inverted">disattivato</div>,
                'PENDING_ACTIVATION': <div className="badge badge-default-inverted">in attesa di attivazione</div>,
              }[member.status || '']}
            </small>
          }
        </li>
      </ul>
      <div className="pt-btn">
        {{
          'ACTIVATED': <span className="btn btn-warning btn-sm" onClick={onToggleMember} disabled={typeof onToggleMember !== 'function'}>Disattiva</span>,
          'SUSPENDED': <span className="btn btn-success btn-sm" onClick={onToggleMember} disabled={typeof onToggleMember !== 'function'}>Attiva</span>,
        }[member.status || '']}
      </div>
    </div>

  </div>
);

export default MemberItem;
